import { Box, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';
import BreadcrumbComponent from './Breadcrumb';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageWrapperProps {
  children: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  gap?: number | string;
}

function PageWrapper({ children, breadcrumbs, gap = 6 }: PageWrapperProps) {
  return (
    <Flex gap={gap} flexDirection="column" pb={24}>
      {breadcrumbs && breadcrumbs.length > 0 ? (
        <BreadcrumbComponent items={breadcrumbs} />
      ) : (
        <Box height="20px" />
      )}
      {children}
    </Flex>
  );
}

export default PageWrapper;
